import ElementQueries from "css-element-queries/src/ElementQueries";
import SmoothScroll from "smooth-scroll";
import stickybits from "stickybits";
import { setLanguageCookie } from "./language";

setLanguageCookie();

(() => {
  ElementQueries.listen();
  ElementQueries.init();

  setTimeout(() => {
    ElementQueries.init();
  }, 1000);
})();

(async () => {
  const svgSpriteResponse = await fetch(
    "/themes/custom/drupack/public/svg-sprite.svg",
    {
      credentials: "include",
    }
  );
  const svgSpriteBody = await svgSpriteResponse.text();

  const container = document.createElement("div");
  container.classList.add("svg-sprite");
  container.innerHTML = svgSpriteBody;
  document.body.insertBefore(container, document.body.childNodes[0]);
})();

(() => {
  stickybits(".is-sticky");

  if (matchMedia("(min-width: 768px)").matches) {
    stickybits(".is-sticky-desktop");
  }
})();

(() => {
  const checkImagesInViewport = () => {
    const lazyBackgroundImages = document.querySelectorAll(
      "[data-lazy-background-image]"
    );
    [...lazyBackgroundImages].forEach((lazyBackgroundImage) => {
      if (
        lazyBackgroundImage.getBoundingClientRect().top < window.innerHeight
      ) {
        const url = lazyBackgroundImage.getAttribute(
          "data-lazy-background-image"
        );

        lazyBackgroundImage.style.backgroundImage = `url(${url})`; // eslint-disable-line no-param-reassign
        lazyBackgroundImage.removeAttribute("data-lazy-background-image");
      }
    });

    const lazyImages = document.querySelectorAll("[data-lazy-image]");
    [...lazyImages].forEach((lazyImage) => {
      if (lazyImage.getBoundingClientRect().top < window.innerHeight) {
        const url = lazyImage.getAttribute("data-lazy-image");

        lazyImage.src = url; // eslint-disable-line no-param-reassign
        lazyImage.removeAttribute("data-lazy-image");

        const srcset = lazyImage.getAttribute("data-lazy-image-srcset");

        if (srcset) {
          lazyImage.srcset = srcset; // eslint-disable-line no-param-reassign
          lazyImage.removeAttribute("data-lazy-image-srcset");
        }

        const alt = lazyImage.getAttribute("data-lazy-image-alt");

        lazyImage.alt = alt || ""; // eslint-disable-line no-param-reassign
        lazyImage.removeAttribute("data-lazy-image-alt");
      }
    });

    if (lazyBackgroundImages.length || lazyImages.length) {
      requestAnimationFrame(checkImagesInViewport);
    }
  };

  requestAnimationFrame(checkImagesInViewport);
})();


(() => {
  new SmoothScroll('a[href*="#"]');
})();

/**
 * Open external links in a new tab.
 * Adds target="_blank" and rel="noopener noreferrer" to all anchor tags
 * that link to external websites.
 */
(() => {
  const EXTERNAL_LINK_ATTR = "data-external-link-processed";

  function isExternalLink(href) {
    if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) {
      return false;
    }
    try {
      const linkUrl = new URL(href, window.location.origin);
      return linkUrl.origin !== window.location.origin;
    } catch {
      return false;
    }
  }

  function processExternalLinks(container = document) {
    container.querySelectorAll(`a[href]:not([${EXTERNAL_LINK_ATTR}])`).forEach((link) => {
      const href = link.getAttribute("href");
      if (isExternalLink(href)) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
        link.setAttribute(EXTERNAL_LINK_ATTR, "");
      }
    });
  }

  processExternalLinks();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          processExternalLinks(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
